import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  //width: 200px;
  margin: 20px 10px;

  @media (min-width: 485px) {
    width: 45%;
  }

  @media (min-width: 700px) {
    width: 30%;
  }

  @media (min-width: 920px) {
    width: 22.5%;
  }

  @media (min-width: 1140px) {
    width: 18%;
  }

  /* @media (max-width: 1140px) and (min-width: none) {
    width: 18%;
    max-width: 250px;
  } */
`;

export const ImageContainer = styled.div`
  /* width: 200px;
  height: 150px; */
  background-color: #fff;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
`;

export const Title = styled.span`
  font-size: 1.125rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 10px;
`;

export const Description = styled.p`
  font-size: 15px;
  color: #fff;
  text-align: justify;
  margin-bottom: 10px;
`;

export const ReedMore = styled.span`
  font-size: 15px;
  font-style: italic;
  margin-top: 10px;
  color: #d31e29;
  font-weight: 600;

  /* &:hover {
    color: red;
    cursor: pointer;
  } */
`;
